module.exports = __webpack_public_path__ + "img/icon_consumable.b9cf9433.png";